import { BellOutlined } from '@ant-design/icons'
import { Card, List, Switch, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { AppHeader, ColumnLayout } from '@/components'
import {
  NotificationContentType,
  NotificationOutletType,
  useGetNotifcationSettingsQuery,
  useNotificationSettingUpdateMutation,
} from '@/generated/graphql'

import s from './notification-setting.module.less'

export const NotificationSettingContainer = () => {
  const [t] = useTranslation()

  const { data, error } = useGetNotifcationSettingsQuery()
  const [update, { loading: updateLoading }] = useNotificationSettingUpdateMutation()

  if (error || !data) {
    return null
  }

  const header = <AppHeader title={t('notificationSetting.title')} avatar={<BellOutlined style={{ fontSize: 28 }} />} />

  const onUpdate = (notificationSettingId: number, isActive: boolean) => {
    if (updateLoading) {
      return
    }
    update({
      variables: {
        notificationSettingId,
        notificationSetting: {
          isActive,
        },
      },
    })
  }

  const contentTypes = [
    NotificationContentType.Comment,
    NotificationContentType.Mention,
    NotificationContentType.Event,
    NotificationContentType.SkillAgree,
    NotificationContentType.Post,
  ]

  const rows = contentTypes.map((contentType) => {
    // [NotificatioOutletType.Browser, NotificatioOutletType.Browser, NotificatioOutletType.Email]
    const settings = [NotificationOutletType.Wechat]
      .map(
        (outletType) =>
          data.viewer.notificationSettings.find((s) => s.contentType === contentType && s.outletType === outletType)!
      )
      .filter(Boolean)

    return (
      <Card key={contentType} title={t(`notificationSetting.contentType.${NotificationContentType[contentType]}`)}>
        <Typography.Paragraph>
          {t(`notificationSetting.desc.${NotificationContentType[contentType]}`)}
        </Typography.Paragraph>
        <List
          size='small'
          dataSource={settings}
          renderItem={(notificationSetting) => (
            <List.Item
              key={notificationSetting.notificationSettingId}
              actions={[
                <Switch
                  key='switch'
                  defaultChecked={notificationSetting.isActive}
                  onChange={() => onUpdate(notificationSetting.notificationSettingId, !notificationSetting.isActive)}
                />,
              ]}
            >
              <List.Item.Meta
                title={t(`notificationSetting.outlet.${NotificationOutletType[notificationSetting.outletType]}`)}
              />
            </List.Item>
          )}
        />
      </Card>
    )
  })

  const middle = <div className={s.container}>{rows}</div>

  return <ColumnLayout header={header} middle={middle} />
}
